export default __webpack_public_path__ + "static/media/logoPopup.e7b64304.png";